import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/settings/pleri-skills')({
  beforeLoad: () => {
    throw redirect({
      to: '/skills',
    });
  },
  component: () => null,
});
